import {Component, OnDestroy, OnInit} from '@angular/core';
import {DataService} from './services/dataService';
import {CordovaUIService, MoI18nService} from '../common/';
import {Subscription} from 'rxjs';
import {SynchroStreamInfo, SynchroStreamStatus} from '../common';
import {PageActionEnum, PageEnum} from './entity';
import {Router} from '@angular/router';
import {LogService} from '../common/log';

@Component({
    selector   : 'app-root',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    /**
     * isNavbarCollapsed
     * @type {boolean}
     */
    private _isNavbarCollapsed = true;
    /**
     * Is Logged ?
     */
    private _isLogin: boolean = false;
    /**
     * Is Table Sync One Time ?
     */
    private _isTableSyncOneTime: boolean = true;
    /**
     * Is Logged ?
     */
    private changedIdentitySubscription: Subscription;
    /**
     * Title
     * @type {string}
     * @private
     */
    private _title: string = '';
    /**
     * Is Syncing.
     */
    private _isSyncing: boolean = false;
    /**
     * Have a sync error
     */
    private _haveSyncError: boolean = false;
    /**
     * Have a connectivity Problem
     */
    private _haveConnectivityProblem: boolean = false;
    /**
     * Subscription Sync Info Stream
     */
    private syncInfoSubscription: Subscription;
    /**
     * Page Contact
     */
    private _isPageContact: boolean = false;
    /**
     * Page Setting
     */
    private _isPageSetting: boolean = false;
    /**
     * Current Section
     */
    private currentSection: string = 'toto';

    /**
     * Constructor
     * @param cordovaService
     * @param dataService
     * @param moI18nService
     * @param logService
     * @param router
     */
    constructor(private cordovaService: CordovaUIService,
                protected dataService: DataService,
                protected moI18nService: MoI18nService,
                protected logService: LogService,
                protected router: Router) {
        this.logService.setRouter(router);
    }

    /**
     * NgOnInit
     */
    public ngOnInit() {
        console.log('OnInit AppComponent');
        this.dataService.getChangedPageStream().subscribe(
            (pageInfo) => {
                setTimeout(() => {
                    this.initPage();
                    switch (pageInfo.action) {
                        case PageActionEnum.NEW_SECTION:
                            if (this.currentSection !== pageInfo.section) {
                                this.currentSection = pageInfo.section;
                                console.log('SECTION', this.currentSection);
                            }
                            break;
                        case PageActionEnum.NEW_PAGE:
                            if (!this._isPageSetting && pageInfo.page === PageEnum.SETTING) {
                                this._isPageSetting = true;
                            } else {
                                if (this._isPageSetting && pageInfo.page !== PageEnum.SETTING) {
                                    this._isPageSetting = false;
                                }
                            }
                            break;
                    }
                });
            }
        );
        this.updateInfoFromDataServive();
        this.changedIdentitySubscription = this.dataService.getChangedIdentityStream().subscribe(
            () => this.updateInfoFromDataServive()
        );
        this.dataService.isReadyToStart().then(() => {
            this.syncInfoSubscription = this.dataService.getInfoStream()
                .subscribe(this.computeSyncInfoStream.bind(this));
            this._isSyncing = this.dataService.isSyncing();
            this.initTableSyncOneTime();

        });
    }

    /**
     * Method to check if the tables are already sync one times.
     */
    private initTableSyncOneTime(): void {
        console.log('*************');
        console.log('*************');
        console.log('*************');
        console.log('initTableSyncOneTime');
        this._isTableSyncOneTime = this.dataService.isSyncTableOnTime();
        if (!this._isTableSyncOneTime) {
            setTimeout(this.initTableSyncOneTime.bind(this), 1000);
        }
    }

    /**
     * NgOnDestroy
     */
    public ngOnDestroy() {
        console.log('OnDestroy AppComponent');
        if (this.changedIdentitySubscription != null) {
            this.changedIdentitySubscription.unsubscribe();
        }
        if (this.syncInfoSubscription != null) {
            this.syncInfoSubscription.unsubscribe();
        }
    }

    /**
     * Update Info From Data Service
     */
    private updateInfoFromDataServive(): void {
        if (this.dataService != null) {
            this._isLogin = this.dataService.isLogged;
        }
    }

    /**
     * Compute the info stream.
     * @param info
     */
    private computeSyncInfoStream(info: SynchroStreamInfo) {
        if (info != null) {
            switch (info.status) {
                case SynchroStreamStatus.CONNECTIVITY_OK:
                    this._haveConnectivityProblem = false;
                    break;
                case SynchroStreamStatus.CONNECTIVITY_KO:
                    this._haveConnectivityProblem = true;
                    break;
                case SynchroStreamStatus.START_SYNCHRO:
                    this._isSyncing = true;
                    this._haveSyncError = false;
                    break;
                case SynchroStreamStatus.ALREADY_SYNCING:
                case SynchroStreamStatus.SEND_DATA:
                case SynchroStreamStatus.SEND_DATA_INFO:
                case SynchroStreamStatus.SEND_FILE:
                case SynchroStreamStatus.SEND_FILE_INFO:
                case SynchroStreamStatus.SEND_FILE_INFO_PROGRESS:
                case SynchroStreamStatus.GET_DATA:
                case SynchroStreamStatus.GET_DATA_INFO:
                case SynchroStreamStatus.GET_FILE:
                case SynchroStreamStatus.GET_FILE_INFO:
                case SynchroStreamStatus.GET_FILE_INFO_PROGRESS:
                    break;
                case SynchroStreamStatus.ERROR_DEXIE:
                case SynchroStreamStatus.ERROR_CORDOVA_FILETRANSFER_GET:
                case SynchroStreamStatus.ERROR_CORDOVA_FILETRANSFER_POST:
                case SynchroStreamStatus.ERROR_CORDOVA_FILE_SAVE:
                case SynchroStreamStatus.ERROR_HTTP_GET:
                case SynchroStreamStatus.ERROR_HTTP_POST:
                case SynchroStreamStatus.ERROR_MPA:
                    this._haveSyncError = true;
                    break;
                case SynchroStreamStatus.END_NORMAL_SYNCHRO:
                case SynchroStreamStatus.END_BY_ERROR_SYNCHRO:
                case SynchroStreamStatus.END_BY_STOP_SYNCHRO:
                    this._isSyncing = false;
                    break;
            }
        }
    }


    /**
     * Scroll to the element
     * @param elementId id of the element
     */
    public scrollInto(elementId: string): void {
        const elementById = document.getElementById(elementId);
        if (elementById !== null) {
            elementById.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
        }
    }


    /**
     * Init the title page.
     */
    private initPage(): void {
        this._title = this.dataService.pageTitle;
    }


    /**
     * Getter.
     * @return {boolean}
     */
    public get isNavbarCollapsed(): boolean {
        return this._isNavbarCollapsed;
    }

    /**
     * Setter
     * @param value
     */
    public set isNavbarCollapsed(value: boolean) {
        this._isNavbarCollapsed = value;
    }

    /**
     * Getter.
     * @return {boolean}
     */
    public get isLogin(): boolean {
        return this._isLogin;
    }

    /**
     * Getter.
     * @return {boolean}
     */
    public get title(): string {
        return this._title;
    }

    /**
     * Getter.
     */
    public get isSyncing(): boolean {
        return this._isSyncing;
    }

    /**
     * Getter.
     */
    public get haveSyncError(): boolean {
        return this._haveSyncError;
    }

    /**
     * Getter.
     */
    public get haveConnectivityProblem(): boolean {
        return this._haveConnectivityProblem;
    }

    /**
     * Getter.
     */
    public get isPageContact(): boolean {
        return this._isPageContact;
    }

    /**
     * Is the current section
     * @param section the section to compare
     */
    public isSection(section: string): boolean {
        return this.currentSection === section;
    }

    /**
     * Getter.
     */
    public get isTableSyncOneTime(): boolean {
        return this._isTableSyncOneTime;
    }

    /**
     * Getter.
     */
    public get isPageSetting(): boolean {
        return this._isPageSetting;
    }
}
